import React, { useEffect, useRef, useState } from "react";
import logoImg from "../../assets/images/logo.png";
import { Offcanvas } from "bootstrap";
import { fetchCandidateDetails } from "model/CandidateDetailsModel";
import { useUserContext } from "libs/context/UserContext";
import { Spinner } from "reactstrap";
import CandidateConversationModal from "pages/CandidateConversationModal/candidate-conversation-model";
import RoadTestModalSection from "pages/RoadTestModal/road-test-modal";
import CandidateCallbackModal from "pages/CandidateCallbackRequest/candidate-callback-request";
import { capitalizeFirstLetter, formatDateWithSuffix, formatUSPhone } from "helpers/GeneralHelper";
import CandidateBackgroundStatusInfoModal from "pages/CandidateBackgroundStatusInfo/candidate-background-status-info";
import CandidateVideoInterviewStatusInfoModal from "pages/CandidateVideoInterviewStatusInfo/candidate-video-interview-status-info-modal";


const CandidateTrackApplication = ({ offcanvasRef, offcanvasInstanceRef }) => {
    const { loading, candidateDetailsData } = useUserContext() || {};
    const [sidebarConversationOpen, setSidebarConversationOpen] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [testDateDateTimeValue, setTestDateDateTimeValue] = useState();
    const [requestCallBackModalOpen, setRequestCallBackModalOpen] = useState(false);
    const interestedOrNot = localStorage?.getItem("InterestedOrNot")
    const [InterestedValue, setInterested] = useState(false);
    const [requestBackgroundStatusInfoModalOpen, setBackgroundStatusInfoModalOpen] = useState(false);
    const [requestVideoInterviewStatusInfoModalOpen, setVideoInterviewStatusInfoModalOpen] = useState(false);
    const [roadTestRawStatus, setRoadTestRawStatus] = useState();

    let doctype = "";

    if (candidateDetailsData?.DriverDetails?.DLRequiredApproval === -1) doctype += (doctype ? ", " : "") + "DL";
    if (candidateDetailsData?.DriverDetails?.SSNRequiredApproval === -1) doctype += (doctype ? ", " : "") + "SSN";
    if (candidateDetailsData?.DriverDetails?.MECRequiredApproval === -1) doctype += (doctype ? ", " : "") + "MEC";

    const closeOffcanvas = () => {
        offcanvasInstanceRef.current?.hide();
    };

    useEffect(() => {
        if (interestedOrNot === 'Interested') {
            setInterested(true)
        }
        else {
            setInterested(false)
        }
    }, [interestedOrNot]);


    return (
        <>
            <div className="active-mob-device">

                <div
                    className="offcanvas offcanvas-start"
                    tabIndex="-1"
                    id="application_status"
                    ref={offcanvasRef}
                >
                    <div className="offcanvas-header justify-content-between align-items-center border-bottom">
                        <h5 className="text-dark">Application Status</h5>
                        <button
                            type="button"
                            className="btn-close text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>

                    <div className="offcanvas-body">
                        <div className="right-common-pattern">
                            {((candidateDetailsData?.Interested) && (candidateDetailsData?.CandidateClinetStatus != 'deactive')) &&
                                <div className="sec-title text-center">
                                    <ul>
                                        {/* Application Submitted */}
                                        {candidateDetailsData?.CandidateClinetOrderStatus &&
                                            <li className={`process-box d-flex align-items-center ${candidateDetailsData?.CandidateClinetOrderStatus != 'Not Ordered' ? 'green-border' : 'red-border'}`}>
                                                <div className="text-details text-start">
                                                    <h5>Background Status
                                                        <span onClick={() => {
                                                        setBackgroundStatusInfoModalOpen(true);
                                                    }}>
                                                        <i className="bx bxs-info-circle video-interview-info"></i>
                                                    </span>
                                                    </h5>
                                                    <p>{candidateDetailsData?.CandidateClinetOrderStatus}</p>
                                                </div>
                                            </li>
                                        }

                                        {/* DOT Medical Card */}
                                        {candidateDetailsData?.CandidateTest?.map((allTests, index) => (

                                            <li key={index} className={`process-box d-flex align-items-center ${['yes', 'Yes'].includes(allTests?.TestStatus) ? 'green-border' : 'red-border'}`}>
                                                <div className="text-details text-start d-flex align-items-center justify-content-between w-100">
                                                    <h5>{allTests?.TestName} {[3, 18].includes(allTests?.JobRequireId) && (
                                                        <>
                                                            <span className="text-red-600">
                                                                *
                                                            </span>
                                                        </>
                                                    )}
                                                        {[17].includes(allTests?.JobRequireId) && (
                                                            <span onClick={() => {
                                                                setVideoInterviewStatusInfoModalOpen(true)
                                                            }}>
                                                                <i className="bx bxs-info-circle video-interview-info"></i>
                                                            </span>
                                                        )}
                                                    </h5>
                                                    <div className="d-flex gap-2">
                                                        {(allTests?.TestName == 'Video Interview' && candidateDetailsData?.InterviewVideoLink) &&
                                                            <div className="icon-button">
                                                                <button className="btn btn-status btn-icon-button" onClick={() => window.open(candidateDetailsData.InterviewVideoLink, "_blank")}>
                                                                    {["no", "No"].includes(allTests?.TestStatus) ?
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 640 640"><path d="M320 312C253.7 312 200 258.3 200 192C200 125.7 253.7 72 320 72C386.3 72 440 125.7 440 192C440 258.3 386.3 312 320 312zM289.5 368L350.5 368C360.2 368 368 375.8 368 385.5C368 389.7 366.5 393.7 363.8 396.9L336.4 428.9L367.4 544L368 544L402.6 405.5C404.8 396.8 413.7 391.5 422.1 394.7C484 418.3 528 478.3 528 548.5C528 563.6 515.7 575.9 500.6 575.9L139.4 576C124.3 576 112 563.7 112 548.6C112 478.4 156 418.4 217.9 394.8C226.3 391.6 235.2 396.9 237.4 405.6L272 544.1L272.6 544.1L303.6 429L276.2 397C273.5 393.8 272 389.8 272 385.6C272 375.9 279.8 368.1 289.5 368.1z" /></svg>
                                                                        :
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
                                                                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                                                                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                                                                        </svg>


                                                                    }
                                                                </button>
                                                            </div>
                                                        }
                                                        {((allTests?.TestName === 'Road test' && allTests?.TestStatus != "no" && allTests?.TestDateValueAppDateTimeFormat) || (allTests?.RawStatus == 'pending' && allTests?.TestName === 'Road test') || (allTests?.RawStatus == 'accepted' && allTests?.TestName === 'Road test')) &&
                                                            <div className="icon-button">
                                                                <button className="btn btn-status btn-icon-button" onClick={() => {
                                                                    setRoadTestRawStatus(allTests?.RawStatus)
                                                                    setTestDateDateTimeValue(allTests?.TestDateValueAppDateTimeFormat)
                                                                    setSidebarOpen(true);
                                                                }}>
                                                                    {/* <i className="bi bi-eye-fill"></i> */}
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
                                                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                                                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        }
                                                        {allTests?.AttachmentLink &&
                                                            <div className="icon-button">

                                                                <button className="btn btn-status">
                                                                    {/* <i className="bi bi-download"></i> */}
                                                                    <a
                                                                        href={allTests?.AttachmentLink}
                                                                        download
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                                                                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                                                            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                                                        </svg>
                                                                    </a>
                                                                </button>
                                                            </div>
                                                        }
                                                        {['yes', 'Yes'].includes(allTests?.TestStatus) &&
                                                            <div className="icon-button">
                                                                <button className="btn btn-status">
                                                                    {/* <i className="bi bi-check2"></i> */}
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check2" viewBox="0 0 16 16">
                                                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        }

                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                    {(candidateDetailsData?.DriverDetails?.RequiredApproval === -1) &&
                                        <p className="mt-2 text-red-600">Your document submission has been rejected. Please re-submit proper document or call us back if you need help.</p>
                                    }
                                    {(doctype && (candidateDetailsData?.DriverDetails?.RequiredApproval != -1) && (candidateDetailsData.DriverDetails.SSNRequiredApproval == -1 || candidateDetailsData.DriverDetails.DLRequiredApproval == -1 || candidateDetailsData.DriverDetails.MECRequiredApproval == -1)) && (
                                        <p className="text-red-600 mt-2">
                                            Your {doctype} document submission has been rejected. Please re-submit proper document or call us back if you need help.
                                        </p>
                                    )}
                                    {candidateDetailsData?.CandidateTest?.some(test => [3, 18].includes(test.JobRequireId)) && (
                                        <p className="mt-2">
                                            * To be conducted by {candidateDetailsData?.Client?.ClientName}
                                        </p>
                                    )}

                                </div>
                            }
                        </div>

                        {/* Call Back Button */}
                        {candidateDetailsData?.CanConversation &&
                            <div className="callback-btn">
                                <div className="d-grid">
                                    <button
                                        type="button"
                                        className="btn btn-callback"
                                        onClick={() => { closeOffcanvas(); setSidebarConversationOpen(true) }}
                                    >
                                        Start a Conversation
                                    </button>
                                </div>
                            </div>
                        }
                        {/* {(!candidateDetailsData?.CanConversation && InterestedValue) && */}
                        {(!candidateDetailsData?.CanConversation) &&

                            <div className="callback-btn">
                                <div className="d-grid">
                                    <button
                                        type="button"
                                        className="btn btn-callback"
                                        onClick={() => { closeOffcanvas(); setRequestCallBackModalOpen(true) }}
                                    >
                                        CallBack Request
                                    </button>
                                </div>
                            </div>
                        }

                        <div className="right-common-pattern mt-2">
                            <div className="sec-title text-center">
                                <div className="sec-title text-center">

                                    {candidateDetailsData?.Recruiter &&
                                        <p className="mt-2">Reach out to your Recruiter <strong>{capitalizeFirstLetter(candidateDetailsData?.Recruiter)} {candidateDetailsData?.RecruiterPhone? formatUSPhone(candidateDetailsData?.RecruiterPhone): null}</strong> .</p>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <RoadTestModalSection setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} testDateDateTimeValue={testDateDateTimeValue} roadTestRawStatus={roadTestRawStatus} />
            <CandidateConversationModal setSidebarConversationOpen={setSidebarConversationOpen} sidebarConversationOpen={sidebarConversationOpen} />
            <CandidateCallbackModal setRequestCallBackModalOpen={setRequestCallBackModalOpen} requestCallBackModalOpen={requestCallBackModalOpen} />
            <CandidateBackgroundStatusInfoModal setBackgroundStatusInfoModalOpen={setBackgroundStatusInfoModalOpen} requestBackgroundStatusInfoModalOpen={requestBackgroundStatusInfoModalOpen} />
            <CandidateVideoInterviewStatusInfoModal setVideoInterviewStatusInfoModalOpen={setVideoInterviewStatusInfoModalOpen} requestVideoInterviewStatusInfoModalOpen={requestVideoInterviewStatusInfoModalOpen} />
        </>
    );
};

export default CandidateTrackApplication;
